import {
  collection,
} from 'common/store/actions';

export const NAMESPACE = 'DEVICE/ALARMS';

const collectionActions = collection.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  TOGGLE_SORT,
  SEARCH,
  PAGINATION_CHANGE,
} = collectionActions.TYPES;

export const {
  loadSuccess,
  loadError,
  toggleSort,
  search,
  paginationChange,
} = collectionActions;

export const load = ({ limit, offset, sort, query, ...props } = {}) => ({
  ...props,
  ...collectionActions.load({ limit, offset, sort, query }),
});
